<template>
  <!-- <el-dialog width="600px" :visible.sync="visible" :title="isAdd ? '新增开票信息' : '修改开票信息'" :close-on-click-modal="false" :close-on-press-escape="false"> -->
    <el-form :model="editDataForm" style="padding-right: 50px;max-width: 500px;min-width:400px;margin-left:1%" :rules="dataRule1" ref="editDataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item prop="caName" label="企业全称" label-width="150px" style="margin-top:30px;">
          <el-input  v-model="editDataForm.caName" disabled placeholder="企业全称"></el-input>
      </el-form-item>
      <el-form-item prop="ratepayerCode" label="购买方纳税人识别号" label-width="150px">
        <el-input v-model="editDataForm.ratepayerCode" disabled placeholder="购买方纳税人识别号"></el-input>
      </el-form-item>
      <el-form-item prop="bankName" label="开户行名称" label-width="150px">
        <el-input v-model="editDataForm.bankName" placeholder="开户行名称"></el-input>
      </el-form-item>
      <el-form-item prop="bankAccount" label="开户账号" label-width="150px">
        <el-input v-model="editDataForm.bankAccount" placeholder="开户账号"></el-input>
      </el-form-item>
      <el-form-item prop="address" label="注册地址" label-width="150px">
        <el-input v-model="editDataForm.address" placeholder="注册地址"></el-input>
      </el-form-item>
      <el-form-item prop="phone" label="注册电话" label-width="150px">
        <el-input v-model="editDataForm.phone" placeholder="注册电话"></el-input>
      </el-form-item>
      <el-form-item prop="pickName" label="收票人姓名" label-width="150px">
        <el-input v-model="editDataForm.pickName" placeholder="收票人姓名"></el-input>
      </el-form-item>
      <el-form-item prop="mobile" label="收票人电话" label-width="150px">
        <el-input v-model="editDataForm.mobile" placeholder="收票人电话"></el-input>
      </el-form-item>
      <el-form-item prop="email" label="收票人邮箱" label-width="150px">
        <el-input v-model="editDataForm.email" placeholder="收票人邮箱"></el-input>
      </el-form-item>
      <el-form-item prop="pickAddress" label="收票人地址" label-width="150px">
        <el-input v-model="editDataForm.pickAddress" placeholder="收票人地址"></el-input>
      </el-form-item>
    </el-form>
    <!-- <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog> -->
</template>

<script>
import debounce from 'lodash/debounce'
import {isEmail, isMobile, testPassword} from '@/utils/validate'
import aesJs from '../../../utils/login-aes'
let checkPhone = (rule, value, callback) => {
    let reg = /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/
    if (!reg.test(value)) {
        callback(new Error('请输入正确的号码'))
    } else {
        callback()
    }
}
let checkNum = (rule,value, callback) => {
    let reg = /^[0-9]*$/
    if (!reg.test(value) || value == '') {
        callback(new Error('请输入正确的开户账号'))
    } else {
        callback()
    } 
}
export default {
  // props:['dataForm'],
  data () {
    return {
      isAdd:false,
      editDataForm:{},
      visible: false,
      roleList: [],
      roleIdListDefault: [],
    }
  },
  computed: {
    dataRule () {
      return {
		      phone: [{ required: true,validator:checkPhone, message: '请输入正确的号码', trigger: 'blur' }],
      }
    },
    dataRule1 () {
      return {
          // code: [{required: true, message: this.$t("validate.required"), trigger: "blur"}],
          caName: [{required: true, message: this.$t("validate.required"), trigger: "blur"}],
          ratepayerCode: [{required: true, message: this.$t("validate.required"), trigger: "blur"}],
          bankName: [{required: true, message: this.$t("validate.required"), trigger: "blur"}],
		      phone: [{ required: true,validator:checkPhone, message: '请输入正确的号码', trigger: 'blur' }],
		      address: [{required: true, message: this.$t("validate.required"), trigger: "blur"}],
		      bankAccount: [{required: true,validator:checkNum, message: '请输入正确的开户账号', trigger: "blur"}],
          pickName: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
          pickAddress: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
          mobile: [{ required: true, message: '输入正确的电话号码', validator: checkPhone, trigger: 'blur' }],
          email: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }]
      }
    }
  },
  created(){
    this.init();
  },
  methods: {
    init () {
      // console.log(this.dataForm)
      // this.visible = true
      // const newArr = JSON.stringify(this.dataForm)
      // this.editDataForm = JSON.parse(newArr)
      this.$http.get('/sys/plat/ticketInfo/page?order=&orderField=&page=1&limit=10&_t=1667466314139',{}).then(({data:res}) => {
        if(res.data && res.data.total != 0){
          this.editDataForm = res.data.list[0]
        }else{
          this.isAdd = true;
          this.editDataForm = {
            caName:this.$store.state.user.caName ? this.$store.state.user.caName  : '',
            ratepayerCode:localStorage.getItem('homeUserInfoId') ? localStorage.getItem('homeUserInfoId') : '',
            bankName:'',
            bankAccount:'',
            address:'',
            phone:'',
            pickName:'',
            mobile:'',
            pickAddress:'',
            email:''
          }
        }
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['editDataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let url = '/sys/plat/ticketInfo/update'
        if(this.isAdd){
          url = '/sys/plat/ticketInfo/save'
        }
        let paramsForm = JSON.parse(JSON.stringify(this.editDataForm));
        this.$http.post(url, {
          ...paramsForm
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.init();
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss" scoped>
.mod-sys__user {
  .dept-list {
    .el-input__inner,
    .el-input__suffix {
      cursor: pointer;
    }
  }
  .role-list {
    .el-select {
      width: 100%;
    }
  }
}
</style>
